export const pagesWithNoFacilityRequirement = ['role', 'user', 'permission', 'role-permission', 'facility'];